import {FeaturesMenu, MenuNodeType, FeatureMenuEntry} from '../api/types/featuresMenu'

export const findSameLevelMenuEntries = (
  featuresMenu: FeaturesMenu,
  featureName: string,
  includeSelf: boolean,
  nodeType?: MenuNodeType
): FeatureMenuEntry[] => {
  const stack: FeaturesMenu[] = [featuresMenu]
  while (stack.length) {
    const currentLevel = stack.pop()
    if (!currentLevel) continue

    const foundEntry =
      currentLevel.findIndex(
        (item) => (nodeType ? item.type === nodeType : true) && item.name === featureName
      ) !== -1

    if (foundEntry) {
      return currentLevel.filter(
        (item) =>
          (nodeType ? item.type === nodeType : true) && (includeSelf || item.name !== featureName)
      )
    }

    currentLevel.forEach((item) => {
      if (item.type === MenuNodeType.Folder) {
        stack.push(item.children)
      }
    })
  }
  return []
}
